import { hot } from 'react-hot-loader/root';
import { connect } from 'react-redux';

import Root from '../components/Root';
import { resetErrorMessage, setApplicationReady } from '../actions/application';
import {
  getApplicationError,
  getLocation,
  getMyPermissions,
  getTenantId,
  getTenants,
  isAuthenticated,
} from '../reducers/analyticsApp';
import { setTenantId, fetchConfig, fetchOptions, checkActualization } from '../actions/project';
import logout from '../actions/logout';
import { fetchSegments } from '../actions/segment';
import { fetchMetainf } from '../actions/events/events';
import { fetchMapping } from '../actions/mapping';
import { fetchLabels } from '../actions/labels';
import { fetchFunnels } from '../actions/funnel';
import resetApp from '../actions/root';
import { fetchPermissions } from '../actions/authorization';
import { fetchDashboards } from '../actions/dashboards/dashboards';
import { fetchTemplates } from '../actions/dashboards/templates';
import updateLocation from '../actions/location';
import updatePreviousLocation from '../actions/previousLocation';

const mapStateToProps = (state) => ({
  applicationError: getApplicationError(state),
  // тенанты могуть быть undefined, если было очищено session и local storage.
  tenants: getTenants(state) || [],
  isAuthenticated: isAuthenticated(state),
  tenantId: getTenantId(state),
  permissions: getMyPermissions(state),
  location: getLocation(state),
});

const mapDispatchToProps = (dispatch) => ({
  setTenantId: (id) => dispatch(setTenantId(id)),
  updateLocation: (location) => dispatch(updateLocation(location)),
  updatePreviousLocation: (location) => dispatch(updatePreviousLocation(location)),
  resetErrorMessage: () => dispatch(resetErrorMessage()),
  fetchConfig: () => dispatch(fetchConfig()),
  logout: () => dispatch(logout()),
  fetchSegments: () => {
    const dispatchAction = dispatch(fetchSegments());
    dispatchAction.name = 'fetchSegments';
    return dispatchAction;
  },
  fetchMetainf: () => {
    const dispatchAction = dispatch(fetchMetainf());
    dispatchAction.name = 'fetchMetainf';
    return dispatchAction;
  },
  fetchMapping: () => {
    const dispatchAction = dispatch(fetchMapping());
    dispatchAction.name = 'fetchMapping';
    return dispatchAction;
  },
  fetchLabels: () => {
    const dispatchAction = dispatch(fetchLabels());
    dispatchAction.name = 'fetchLabels';
    return dispatchAction;
  },
  fetchFunnels: () => {
    const dispatchAction = dispatch(fetchFunnels());
    dispatchAction.name = 'fetchFunnels';
    return dispatchAction;
  },
  setApplicationReady: () => dispatch(setApplicationReady()),
  resetApp: () => dispatch(resetApp()),
  fetchOptions: () => dispatch(fetchOptions()),
  fetchPermissions: () => dispatch(fetchPermissions()),
  fetchDashboards: () => dispatch(fetchDashboards()),
  fetchTemplates: () => dispatch(fetchTemplates()),
  checkActualization: () => dispatch(checkActualization()),
});

export default connect(mapStateToProps, mapDispatchToProps)(hot(Root));
